import {
  CategoryFacetChips
} from "./chunk-4IGTQ2OC.mjs";
import {
  SearchResultsSort
} from "./chunk-VKTI7EPI.mjs";
import {
  SearchResultsTable
} from "./chunk-YGDZQCRH.mjs";
import {
  getProductDescription
} from "./chunk-P7U6L3AP.mjs";
import "./chunk-XV7TMGN6.mjs";
import {
  InlineError
} from "./chunk-XU42F452.mjs";
import {
  ShareLinkButton
} from "./chunk-BARDMAFJ.mjs";
import {
  SearchField
} from "./chunk-OJCD46GK.mjs";

// src/SearchResults.tsx
import { useMemo } from "react";
import Box from "@mui/material/Box/index.js";
import Typography from "@mui/material/Typography/index.js";
import SearchIcon from "@mui/icons-material/esm/Search.js";
import CircularProgress from "@mui/material/CircularProgress/index.js";
import { useTranslation } from "react-i18next";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var SearchResults = ({
  q,
  sortKey,
  onSortChange,
  onSelectLeafCategory,
  data,
  total,
  categoryFacets,
  loading,
  error,
  categories
}) => {
  const { t } = useTranslation();
  const idToName = useMemo(
    () => new Map(
      categories.map((category) => [String(category.id), category.name])
    ),
    [categories]
  );
  const facets = useMemo(
    () => categoryFacets.map(({ groupId, count }) => {
      const categoryId = String(groupId);
      return {
        categoryId,
        categoryName: idToName.get(categoryId) ?? categoryId,
        count
      };
    }),
    [categoryFacets, idToName]
  );
  const visibleResults = useMemo(() => {
    let results = data;
    if (sortKey === "name_asc") {
      results = [...results].sort(
        (a, b) => getProductDescription(a).localeCompare(getProductDescription(b))
      );
    }
    return results;
  }, [data, sortKey]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Typography, { variant: "h4", fontWeight: 700, gutterBottom: true, children: t("searchResults.title") }),
    /* @__PURE__ */ jsx(Box, { sx: { maxWidth: 480, mb: 3 }, children: /* @__PURE__ */ jsx(
      SearchField,
      {
        initialValue: q,
        label: /* @__PURE__ */ jsxs(Typography, { sx: { display: "flex", alignItems: "center" }, children: [
          /* @__PURE__ */ jsx(SearchIcon, { sx: { marginRight: "0.5rem" } }),
          t("searchBoxHero.searchBoxLabel")
        ] })
      },
      q
    ) }),
    !q && /* @__PURE__ */ jsx(Typography, { color: "text.secondary", children: t("searchResults.emptyQuery") }),
    q && loading && /* @__PURE__ */ jsx(Box, { sx: { display: "flex", justifyContent: "center", py: 6 }, children: /* @__PURE__ */ jsx(CircularProgress, {}) }),
    q && !loading && error && /* @__PURE__ */ jsx(InlineError, {}),
    q && !loading && !error && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Typography, { color: "text.secondary", sx: { mb: 3 }, children: t("searchResults.resultsCount", { count: total, query: q }) }),
      total === 0 && /* @__PURE__ */ jsxs(Box, { sx: { py: 4 }, children: [
        /* @__PURE__ */ jsx(Typography, { children: t("searchResults.noResults", { query: q }) }),
        /* @__PURE__ */ jsx(Typography, { color: "text.secondary", children: t("searchResults.noResultsHint") })
      ] }),
      total > 0 && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsxs(
          Box,
          {
            sx: {
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
              alignItems: "flex-start",
              gap: 2,
              mb: 1
            },
            children: [
              /* @__PURE__ */ jsx(
                CategoryFacetChips,
                {
                  facets,
                  categories,
                  onSelectLeaf: onSelectLeafCategory
                }
              ),
              /* @__PURE__ */ jsxs(Box, { sx: { display: "flex", alignItems: "center", gap: 1 }, children: [
                /* @__PURE__ */ jsx(SearchResultsSort, { sortKey, onChange: onSortChange }),
                /* @__PURE__ */ jsx(ShareLinkButton, { tooltip: t("searchResults.copyLink") })
              ] })
            ]
          }
        ),
        /* @__PURE__ */ jsx(SearchResultsTable, { results: visibleResults, idToName })
      ] })
    ] })
  ] });
};
export {
  SearchResults
};
